module.exports = __webpack_public_path__ + "static/media/logo-one-team.d2435b16.png";